import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'

const PAYMENTS_PREFIX = 'cabinet:payments'
const p = (name: string) => PAYMENTS_PREFIX + ':' + name

export const PAYMENT_CATALOG_VIEW_NAME = p('catalog-view')

const PaymentsCatalogView = () => import('./views/CatalogOfPayments.vue')

const BASE_MODEL_NAME = 'payments/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route(
      'catalog/',
      PaymentsCatalogView,
      PAYMENT_CATALOG_VIEW_NAME, //cabinet/payments/catalog
      {
        meta: {
          title: () => $t('Мої платежі'),
        },
    }),
  ]
}

export { BASE_MODEL_NAME }